import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../../services/redux/types";

export const selectComparisonState = (state: RootState) => state.comparisonState;

export const selectComparisonObjects = createSelector(
  selectComparisonState,
  (state) => state.comparisonObjects
);

export const selectSelectedComparisonObject = createSelector(
  selectComparisonState,
  (state) => state.selectedComparisonObject
);

export const selectComparisonValue = createSelector(
  selectComparisonState,
  (state) => state.comparisonObjectValue
);

export const selectComparisonModels = createSelector(
  selectComparisonState,
  (state) => state.models
);

export const selectComparisonLoading = createSelector(
  selectComparisonState,
  (state) => state.isLoading
);

export const selectMessageLoading = createSelector(
  selectComparisonState,
  (state) => state.isMessageLoading
);